module.exports = __webpack_public_path__ + "static/show-subcategories-grid-6a4f7a571fa9339acc510ac524326388.png";